(() => {
  // app/scripts/balance-selector.js
  var { debounceTime } = theme;
  customElements.define(
    "balance-selector",
    class extends HTMLElement {
      constructor() {
        super();
        this.className = ".jsBalanceItem";
        const listBlock = this.querySelectorAll(this.className);
        if (!listBlock.length)
          return;
        this.insertAdjacentHTML("beforeend", `<style>balance-selector .jsBalanceItem{ min-height: var(--balance-height, auto); }</style>`);
        this.init();
        this.resize();
      }
      init() {
        this.style.opacity = 0;
        let maxHeight = 0;
        this.style.setProperty("--balance-height", "0px");
        this.querySelectorAll(this.className).forEach((item) => {
          item.style.height = null;
          let clientHeight = item.clientHeight;
          if (clientHeight > maxHeight) {
            maxHeight = clientHeight;
          }
        });
        this.style.setProperty("--balance-height", maxHeight + "px");
        setTimeout(() => {
          this.style.opacity = 1;
        }, 200);
      }
      resize() {
        window.addEventListener("resize", debounceTime((e) => {
          this.init(e);
        }, 300).bind(this));
      }
    }
  );
  document.addEventListener("shopify:section:load", (event) => {
    const { target } = event;
    const container = target.querySelector(".container");
    const balanceSelector = container.querySelector("balance-selector");
    balanceSelector.init();
  });
})();
